/* Pages orphelines */
import PageAjoutCopro from '../components/App/PageAjoutCopro';
import PageChangerMdp from '../components/App/PageChangerMdp';
import PageAide from '../components/App/PageAide';
import PageReaction from '../components/App/PageReaction';

/* Pages réutilisées */
import { DocumentLocal, DocumentEnligne } from '../components/PageDocument';
import Message from '../components/PageMessage';

/* Accueil */
import Accueil from '../components/Accueil';

/* Mon Syndic */
import MonSyndic from '../components/MonSyndic';

/* mes Informations */
import MesInfos from '../components/MesInfos';
import PageHistoCompta from '../components/MesInfos/PageHistoCompta';
import PageCoordonnees from '../components/MesInfos/PageCoordonnees';
import PageEcourrier from '../components/MesInfos/PageEcourrierNG';
//import PageConsentementLRE from '../components/MesInfos/PageConsentementLRE';
import PagePaiement from '../components/MesInfos/Paiement/PagePaiement';
import PageSaisieIBAN from '../components/MesInfos/Prelevement/PageSaisieIBAN';
import PageSignerMandat from '../components/MesInfos/Prelevement/PageSignerMandat';
import PageGererPrelevement from '../components/MesInfos/Prelevement/PageGererPrelevement';
import PageDetailsAvance from '../components/MesInfos/PageDetailsAvance';
/* Mes Votes */
import MonAG from '../components/MonAG';
import MesVotes from '../components/MonAG/MesVotes';
import MaSignature from '../components/MonAG/MaSignature';

/* Ma Messagerie */
import MaMess from '../components/MaMess';
import PageEcrire from '../components/MaMess/PageEcrire';
import MaMessNG from '../components/MaMess/MaMessNG';
import PageEcrireNG from '../components/MaMess/PageEcrireNG';
import PageTicketNG from '../components/MaMess/PageTicketNG';

/* Mes Documents */
import MesDocs from '../components/MesDocs';
import PageSuiviCourrier from '../components/MesDocs/PageSuiviCourrier';

/* Ma Copropriété */
import MaCopro from '../components/MaCopro';
import PageProprietaires from '../components/MaCopro/PageProprietaires';
import PageProprietairesCS from '../components/MaCopro/PageProprietairesCS';
import PageNews from '../components/MaCopro/PageNews';
import PageBanques from '../components/MaCopro/PageBanques';
import PageBanqueHisto from '../components/MaCopro/PageBanqueHisto';
import PageBanqueReleves from '../components/MaCopro/PageBanqueReleves';
import PageDepenses from '../components/MaCopro/PageDepenses';
import PageFournisseurs from '../components/MaCopro/PageFournisseurs';
import PageBalance from '../components/MaCopro/PageBalance';



export const RoutesGenerales = [
    {
        path: '/AjoutCopro',
        titre: 'Ajouter une copropriété',
        component: PageAjoutCopro,
        sidenav: false,
    },
    {
        path: '/ChangerMotdepasse',
        titre: 'Changer mon mot de passe',
        component: PageChangerMdp,
        sidenav: false,
    },
    {
        path: '/Aide',
        titre: 'Aide',
        component: PageAide,
        sidenav: false,
    },
];

const RoutesCopRattacheeBase = [
    /* Pages orphelines */
    {
        path: '/Reaction',
        titre: 'Retour d&apos;information',
        component: PageReaction,
        sidenav: false,
    },
    /* Accueil */
    {
        path: '/Accueil',
        titre: 'Accueil',
        component: Accueil,
        sidenav: true,
        picto: 'fa-home',
    },
    /* Mon Syndic */
    {
        path: '/MonSyndic',
        titre: 'Mon syndic',
        component: MonSyndic,
        sidenav: true,
        picto: 'fa-suitcase',
    },
    /* Mes Informations */
    {
        path: '/MesInformations/MonHistorique',
        titre: 'Mon historique',
        component: PageHistoCompta,
        sidenav: false,
    },
    {
        path: '/MesInformations/Coordonnees',
        titre: 'Mes coordonnées',
        component: PageCoordonnees,
        sidenav: false,
    },
    {
        path: '/MesInformations/Ecourrier',
        titre: 'Mon courrier électronique',
        component: PageEcourrier,
        sidenav: false,
    },
    // {
    //     path: '/MesInformations/ConsentementLRE',
    //     titre: 'Mon consentement LRE',
    //     component: PageConsentementLRE,
    //     sidenav: false,
    // },
    {
        path: '/MesInformations/Document',
        titre: 'Document',
        component: DocumentLocal,
        sidenav: false,
    },
    {
        path: '/MesInformations/Gestionnaire',
        titre: 'Mon gestionnaire',
        component: PageCoordonnees,
        sidenav: false,
    },
    {
        path: '/MesInformations/SaisieRIB',
        titre: 'Saisie RIB',
        component: PageSaisieIBAN,
        sidenav: false,
    },
    {
        path: '/MesInformations/SaisieRIB/Signature',
        titre: 'Signature électronique du mandat',
        component: PageSignerMandat,
        sidenav: false,
    },
    {
        path: '/MesInformations/GererPrelevement',
        titre: 'Gérer mon prélèvement',
        component: PageGererPrelevement,
        sidenav: false,
    },
    {
        path: '/MesInformations/DetailsAvance',
        titre: 'Mon avance détenue',
        component: PageDetailsAvance,
        sidenav: false,
    },
    {
        path: '/MesInformations/Paiement',
        titre: 'Paiement',
        component: PagePaiement,
        sidenav: false,
    },
    {
        path: '/MesInformations',
        titre: 'Mes informations',
        component: MesInfos,
        sidenav: true,
        picto: 'fa-user',
    },
    // MonAG (Liste votes pour la reunion selectionnée)
    {
        path: '/MesInformations/MonAG',
        titre: 'Mon AG',
        component: MonAG,
        sidenav: false,
    },
    {
        path: '/MesInformations/MonAG/:id',
        titre: 'Mon AG',
        component: MonAG,
        sidenav: false,
    },
    {
        path: '/MesInformations/MonAG/MesVotes',
        titre: 'Mes Votes',
        component: MesVotes,
        sidenav: false,
    },
    {
        path: '/MesInformations/MonAG/MesVotes/:id',
        titre: 'Mon Vote',
        component: MesVotes,
        sidenav: false,
    },
    {
        path: '/MesInformations/MonAG/MesVotes/MaSignature',
        titre: ' Ma Signature',
        component: MaSignature,
        sidenav: false,
    },
    {
        path: '/MesInformations/MonAG/MesVotes/MaSignature/:id',
        titre: 'Ma Signature',
        component: MaSignature,
        sidenav: false,
    },
    /* Ma Messagerie */
    {
        path: '/MaMessagerie/Repondre',
        titre: 'Répondre',
        component: PageEcrire,
        sidenav: false,
    },
    {
        path: '/MaMessagerie/Message',
        titre: 'Message',
        component: Message,
        sidenav: false,
    },
    // MaMessNG (Liste sous forme de conversation)
    {
        path: '/MaMessagerie',
        titre: 'Ma messagerie',
        component: MaMess, //MaMessNG
        sidenav: true,
        picto: 'fa-comments',
    },
    {
        path: '/MaMessagerie/Ecrire',
        titre: 'Écrire',
        component: PageEcrireNG,
        sidenav: false,
    },
    {
        path: '/MaMessagerie/Conversation',
        titre: 'Conversation',
        component: PageTicketNG,
        sidenav: false,
    },
    /* Mes Documents */
    {
        path: '/MesDocuments/Document',
        titre: 'Document',
        component: DocumentEnligne,
        sidenav: false,
    },
    {
        path: '/MesDocuments/SuiviCourrier',
        titre: 'Suivi courrier',
        component: PageSuiviCourrier,
        sidenav: false,
    },
    {
        path: '/MesDocuments',
        titre: 'Mes documents',
        component: MesDocs,
        sidenav: true,
        picto: 'fa-archive',
    },
    /* Ma Copropriété */
    {
        path: '/MaCopropriete/Proprietaires',
        titre: 'Liste des propriétaires',
        component: PageProprietaires,
        sidenav: false,
    },
    {
        path: '/MaCopropriete/ProprietairesCS',
        titre: 'Liste des propriétaires',
        component: PageProprietairesCS,
        sidenav: false,
    },
    {
        path: '/MaCopropriete/News',
        titre: 'News',
        component: PageNews,
        sidenav: false,
    },
    {
        path: '/MaCopropriete/News/Message',
        titre: 'Message',
        component: Message,
        sidenav: false,
    },
    {
        path: '/MaCopropriete/Banques/Historique',
        titre: 'Historique',
        component: PageBanqueHisto,
        sidenav: false,
    },
    {
        path: '/MaCopropriete/Banques/Releves',
        titre: 'Relevés banque',
        component: PageBanqueReleves,
        sidenav: false,
    },
    {
        path: '/MaCopropriete/Banques',
        titre: 'Comptes bancaires',
        component: PageBanques,
        sidenav: false,
    },
    {
        path: '/MaCopropriete/Depenses',
        titre: 'Liste des dépenses',
        component: PageDepenses,
        sidenav: false,
    },
    {
        path: '/MaCopropriete/Balance',
        titre: 'Balance comptable',
        component: PageBalance,
        sidenav: false,
    },
    {
        path: '/MaCopropriete/Fournisseurs',
        titre: 'Liste des fournisseurs',
        component: PageFournisseurs,
        sidenav: false,
    },
    {
        path: '/MaCopropriete',
        titre: 'Ma copropriété',
        component: MaCopro,
        sidenav: true,
        picto: 'fa-building',
    },

];

// const RoutesCopRattacheeDev = [
//     {
//         path: '/NouvelleMessagerie/Ecrire',
//         titre: 'Écrire',
//         component: PageEcrireNG,
//         sidenav: false,
//     },
//     {
//         path: '/NouvelleMessagerie/Conversation',
//         titre: 'Conversation',
//         component: PageTicketNG,
//         sidenav: false,
//     },
//     {
//         path: '/NouvelleMessagerie',
//         titre: 'Ma messagerie (NG)',
//         component: MaMessNG,
//         sidenav: true,
//         picto: 'fa-comments',
//     },
// ];

export const RoutesCopRattachee =
    //process.env.NODE_ENV === 'development' ? 
    //RoutesCopRattacheeBase.concat(RoutesCopRattacheeDev) : 
    RoutesCopRattacheeBase;



// WEBPACK FOOTER //
// ./src/App_Data/Routes.js